import packageInfo from '../../../package.json';
import { PLUGIN_NAME } from './constants';
import pageBuilderComponent from './page-builder-components';

const { version } = packageInfo;

async function load(app) {
  app.log.debug('loaded boat content plugin');

  app.events.on('load:custom:page-builder:component', addComponent => {
    Object.keys(pageBuilderComponent).forEach(key =>
      addComponent({ key, component: pageBuilderComponent[key] })
    );
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
